module.exports = __webpack_public_path__ + "img/logo.950954a6.png";